<template>
  <v-card flat tile class="assumptions-clickable readonly-column" @click="clickHandler()">
    <span>{{ params.contents }}</span>      
  </v-card>
</template>

<script>
  export default {
    name: 'AssumptionsClickableCell',
    methods: {
      clickHandler: function () {
        this.params.onClick(this.params);
      }
    },
  }
</script>

<style scoped lang="scss">
  .assumptions-clickable{
      width: 100%;
      height: 100%;
      cursor: pointer;
  }
</style>
